(function () {
  'use strict';

  var STATS_ID = '[id$="__multicolumn_wi3djB"]';
  var CTA_ID   = '[id$="__icons_bar"]';

  var COUNTER_CONFIG = {
    '4M+':        { from: 0,    to: 4,       suffix: 'M+', commas: false },
    'Since 2010': { from: 1990, to: 2010,    prefix: 'Since ', suffix: '' },
    '15+':        { from: 0,    to: 15,      suffix: '+',  commas: false },
    '100%':       { from: 0,    to: 100,     suffix: '%',  commas: false }
  };

  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function fmt(n, commas) {
    var rounded = Math.round(n);
    if (!commas) return rounded.toString();
    return rounded.toLocaleString('en-US');
  }

  function animateCounter(el, cfg, duration) {
    var start   = null;
    var range   = cfg.to - cfg.from;
    var prefix  = cfg.prefix  || '';
    var suffix  = cfg.suffix  || '';
    var commas  = cfg.commas  || false;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      el.textContent = prefix + fmt(cfg.from + easeOut(progress) * range, commas) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function initStats() {
    var section = document.querySelector(STATS_ID);
    if (!section) return;

    var fired = false;

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || fired) return;
        fired = true;
        obs.disconnect();

        // Trigger CSS stagger animations
        section.classList.add('noxor-stats-visible');

        // Animate each counter
        section.querySelectorAll('h3.title').forEach(function (el) {
          var key = el.textContent.trim();
          var cfg = COUNTER_CONFIG[key];
          if (!cfg) return;
          // Set initial value immediately so there's no flash
          el.textContent = (cfg.prefix || '') + fmt(cfg.from, cfg.commas) + (cfg.suffix || '');
          animateCounter(el, cfg, 2000);
        });
      });
    }, { threshold: 0.25 });

    observer.observe(section);
  }

  function initCTA() {
    var section = document.querySelector(CTA_ID);
    if (!section) return;

    var fired = false;

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || fired) return;
        fired = true;
        obs.disconnect();
        section.classList.add('noxor-cta-visible');
      });
    }, { threshold: 0.4 });

    observer.observe(section);
  }

  function init() {
    initStats();
    initCTA();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
